import { useEffect, useState } from 'react';

const OfflineToast = ({ message, visible, type }) => {
  const [showAnimation, setShowAnimation] = useState(false);
  const bgColor = type === 'online' ? 'bg-green-500' : 'bg-red-500';

  useEffect(() => {
    visible ? setShowAnimation(true) : setShowAnimation(false);
  }, [visible]);

  return (
    visible && (
      <div
        className={`fixed z-20 px-4 py-2 text-white transform -translate-x-1/2 rounded-lg shadow-lg top-5 left-1/2
        transition-all duration-500 ease-in-out
        ${bgColor}
        ${
          showAnimation
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 -translate-y-5'
        }
      `}
      >
        {message}
      </div>
    )
  );
};

export default OfflineToast;
